<button mat-icon-button
        [matMenuTriggerFor]="menu">
  <mat-icon>{{ this.data?.appBarDropdown?.menuIcon ?? "" }}</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let menuItem of this.menuItems">
    <button mat-menu-item
            (click)="onClickAppBarMenuItem(menuItem)">
      <mat-icon *ngIf="menuItem.icon">{{menuItem.icon}}</mat-icon>
      <span>{{ menuItem.label }}</span>
    </button>
  </ng-container>
</mat-menu>
